export default __webpack_public_path__ + "static/media/welcomeLandingbg.8610e6a8.png";